import React from "react";
import Button from "components/button";
import { connect } from "react-redux";
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function AccessButton(props) {
    const {
        label,
        backLabel,
        baseRoute,
        recordId,
        recordData,
        iconStart,
        iconEnd,
        mode = "view",
        withBack = false,
        backUrl,
        btnClass = "btn-emerald",
        state,
        to,
        onBack,
        onClick,
        ...rest 
    } = props;

    const navigate = useNavigate();

    const handleBack = () => {
         if (onBack) {
            onBack();
        } else {
            navigate(backUrl ?? baseRoute);
        }
    };

    const handleView = () => {
        console.log('Navigating with state:', { ...state, recordData });
        if (baseRoute && recordId) {
            navigate(`${baseRoute}/${recordId}/view`, { 
                state: { 
                    ...state,
                    recordData 
                } 
            });
        }
    };

    const handleClick = () => {
        if (onClick) {
            onClick(); 
        } else if (to) {
            navigate(to, { state });
        } else {
            handleView();
        }
    };

    return (
        <div className="" {...rest}>
            {mode === "view" && (
                <div className="flex w-full items-center">
                    {withBack && (
                        <Button
                            type="button"
                            className="access-button btn-back px-2"
                            onClick={handleBack}
                        >
                            <LuArrowLeft className="w-4 h-4" />

                            {backLabel && (
                                <span className="hidden lg:inline ml-2 text-base font-medium">
                                    {backLabel}
                                </span>
                            )}
                        </Button>
                    )}

                    {label && (
                        <Button
                            type="button"
                            className={`access-button w-full flex items-center justify-center py-2 ${btnClass}`}
                            onClick={handleClick}
                        >
                            {iconStart && (
                                <span className="flex items-center justify-center mr-2">
                                    {React.cloneElement(iconStart, {
                                        className:
                                            iconStart.props.className ?? "w-4 h-4",
                                    })}
                                </span>
                            )}

                            <span className="min-w-0 whitespace-normal text-center leading-normal py-1">
                                {label}
                            </span>

                            {iconEnd && (
                                <span className="flex items-center justify-center ml-2">
                                    {React.cloneElement(iconEnd, {
                                        className:
                                            iconEnd.props.className ?? "w-4 h-4",
                                    })}
                                </span>
                            )}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccessButton);
